import React from 'react'
import styled from 'styled-components'
import { SearchInput, TextArea } from '../Common/CommonStyle'

import {
  HelveticaNeueBold14,
  NudistaBold12,
  NudistaBold14,
  NudistaMedium12,
  NudistaMedium9,
  NudistaMedium14,
  NudistaSemiBold11,
  NudistaSemiBold13,
  NudistaBold18,
  NudistaBoldCustomFont,
} from '../Common/Fonts'
import MapWrapper from './Map'
import {
  UserProfilePicture,
  UserProfilePictureHolder,
} from '../Common/CommonStyle'
import ZoomTab from './ZoomTab'

import {
  Icon,
  RowFlexDiv,
  ColumnFlexDiv,
  SearchFlexDiv,
  SInput,
  P,
} from '../Common/CommonStyle'

import { NudistaMedium11 } from '../Common/Fonts'
import RadioButton from '../Common/RadioButton'

const ChatTab = ({
  mosiacView = { mosiacView },
  setMosiacView = { setMosiacView },
}) => {
  const [chatView, setChatView] = React.useState(false)
  const [shareView, setShareView] = React.useState(false)
  const [liveView, setLiveView] = React.useState(false)

  return (
    <ColumnFlexDiv
      width='25%'
      height='92vh'
      justifyContent='flex-start'
      alignItems='flex-start'
      gap='2%'
    >
      <ChatScreen
        width={chatView ? '24.1%' : '0px'}
        chatView={chatView}
        setChatView={setChatView}
      />
      <ShareScreen
        width={shareView ? '24.1%' : '0px'}
        shareView={shareView}
        setShareView={setShareView}
      />
      <LiveScreen
        width={liveView ? '24.1%' : '0px'}
        liveView={liveView}
        setLiveView={setLiveView}
      />

      {/* {!(chatView || shareView || liveView) ? ( */}
      <MainView
        mosiacView={mosiacView}
        setMosiacView={setMosiacView}
        setChatView={setChatView}
        setShareView={setShareView}
        setLiveView={setLiveView}
      />
      <ColumnFlexDiv
        width='100%'
        height='8%'
        // backgroundColor='#123456'
        alignSelf='flex-end'
      >
        <ZoomTab zoomView={mosiacView} setZoomView={setMosiacView} />
      </ColumnFlexDiv>

      {/* ) : (
        <></>
      )} */}
    </ColumnFlexDiv>
  )
}

const MainView = ({
  mosiacView,
  setMosiacView,
  setChatView,
  setShareView,
  setLiveView,
}) => {
  return (
    <ColumnFlexDiv
      height='88%'
      width='100%'
      justifyContent='flex-start'
      alignItems='flex-start'
      backgroundColor='#F5F4F7'
      gap='18px'
    >
      <ColumnFlexDiv
        width='100%'
        gap='4px'
        justifyContent='flex-start'
        // alignItems='flex-start'
      >
        <MapWrapper width='100%' height='172px' />
        <ColumnFlexDiv height='140px' gap='10px'>
          <RowFlexDiv
            width='100%'
            height='35px'
            gap='2%'
            justifyContent='flex-start'
          >
            <Button
              width='48%'
              height='100%'
              icon='/images/mainView/assignmentsView/actions-share.svg'
              title='Share'
              padding='2%'
              backgroundColor='#09070B'
              handleClick={() => {
                setShareView(true)
              }}
            />
            <Button
              width='48%'
              height='100%'
              icon='/images/mainView/assignmentsView/actions-zip.svg'
              title='Generate ZIP'
              backgroundColor='#09070B'
            />
          </RowFlexDiv>
          <RowFlexDiv
            width='100%'
            height='35px'
            gap='2%'
            justifyContent='flex-start'
          >
            <Button
              width='100%'
              height='100%'
              icon='/images/mainView/assignmentsView/actions-chat.svg'
              title='Chat'
              backgroundColor='#8C47ED'
              handleClick={() => {
                setChatView(true)
              }}
            />
          </RowFlexDiv>
          <RowFlexDiv
            width='100%'
            height='35px'
            gap='2%'
            justifyContent='flex-start'
            // marginBottom='5px'
          >
            <Button
              width='100%'
              height='100%'
              icon='/images/mainView/assignmentsView/actions-liveinspection.svg'
              title='Live Inspection'
              backgroundColor='#6906F4'
              handleClick={() => {
                setLiveView(true)
              }}
            />
          </RowFlexDiv>
        </ColumnFlexDiv>
      </ColumnFlexDiv>

      <ColumnFlexDiv
        width='100%'
        height='34vh'
        // marginTop='2px'
        // padding='1% 2% 2% 5%'
        backgroundColor='#F5F4F7'
        alignItems='center'
        gap='5px'
      >
        <RowFlexDiv
          justifyContent='flex-start'
          height='10%'
          width='90%'
          gap='5px'
        >
          <Icon src='/images/mainView/assignmentsView/gallery-toolkit.svg' />

          <HelveticaNeueBold14 color='primary'>
            GALLERY TOOLKIT
          </HelveticaNeueBold14>
        </RowFlexDiv>
        <SearchFlexDiv
          width='90%'
          height='31px'
          borderRadius='8px'
          backgroundColor='#ffffff'
          boxShadow='0 3px 6px 0 rgba(0, 0, 0, 0.16)'
          justifyContent='flex-start'
        >
          <SInput
            paddingLeft='15px'
            height='70%'
            width='87%'
            placeholder={'Sort by Damage'}
          />
          <Icon src='/images/mainView/assignmentsView/dropdown.svg' />
        </SearchFlexDiv>
        <ColumnFlexDiv
          width='90%'
          height='45%'
          backgroundColor='#FFFFFF'
          borderRadius='5px'
          justifyContent='space-between'
          alignItems='center'
          padding='5px 0px 5px 0px'
        >
          <NudistaMedium12 opacity='0.6'>
            Bulk Caption Selected Photos...
          </NudistaMedium12>
          <RowFlexDiv
            backgroundColor='#FB8F02'
            width='90%'
            height='35px'
            borderRadius='5px'
            gap='10px'
            justifyContent='center'
          >
            <Icon src='/images/mainView/assignmentsView/voice-text.svg' />
            <NudistaMedium12 white>Voice to Text Caption</NudistaMedium12>
          </RowFlexDiv>
        </ColumnFlexDiv>

        <RowFlexDiv width='90%' height='25px'>
          <NudistaBold12 color='lightBlack'>
            Add 7 Photos to Report
          </NudistaBold12>
          <RadioButton checkedColor='#FB8F02' />
        </RowFlexDiv>
      </ColumnFlexDiv>
    </ColumnFlexDiv>
  )
}

const IconDiv = ({ image, backgroundColor }) => {
  return (
    <RowFlexDiv
      height='40px'
      width='40px'
      backgroundColor={backgroundColor}
      justifyContent='center'
      borderRadius='5px'
    >
      <Icon src={image} />
    </RowFlexDiv>
  )
}
const SendTab = () => {
  return (
    <SearchFlexDiv
      width='96%'
      justifyContent='center'
      alignSelf='center'
      height='31px'
      backgroundColor='#FFFFFF'
      marginBottom='3%'
      borderRadius='10px'
      boxShadow='3px 3px 6px 3px rgba(0, 0, 0, 0.16)'
      padding='2%'
    >
      <SInput
        placeholderFont='12px'
        paddingLeft='10px'
        width='75%'
        height='100%'
        placeholder={'Text Message...'}
      />
      <SearchFlexDiv
        width='25%'
        height='100%'
        justifyContent='flex-end'
        gap='10%'
      >
        <RowFlexDiv
          height='100%'
          width='50px'
          backgroundColor='#6f03fd'
          justifyContent='center'
          borderRadius='5px'
        >
          <Icon src='/images/mainView/assignmentsView/bxs-paper-plane.svg' />
        </RowFlexDiv>
        <RowFlexDiv
          height='100%'
          width='50px'
          justifyContent='center'
          borderRadius='5px'
          backgroundColor='#FB8F02'
        >
          <Icon src='/images/mainView/assignmentsView/speaker.svg' />
        </RowFlexDiv>
      </SearchFlexDiv>
    </SearchFlexDiv>
  )
}

const ChatScreen = ({ width, chatView, setChatView }) => {
  return (
    <SideDiv
      right={chatView ? '0%' : '25%'}
      width={width}
      visibility={chatView ? 'visible' : 'hidden'}
      opacity={chatView ? 1 : 0}
      position='absolute'
      height='100vh'
      zIndex='11'
      padding='1%'
      boxShadow='0 3px 9px 0 rgba(0, 0, 0, 0.19)'
      backgroundColor='#ffffff'
    >
      <RowFlexDiv
        width={chatView ? '100%' : '0px'}
        marginTop='20px'
        justifyContent='flex-end'
      >
        <Icon
          width='15px'
          height='15px'
          src='/images/mainView/assignmentsView/dropdown.svg'
          transform='rotate(90deg)'
        />
      </RowFlexDiv>
      <ColumnFlexDiv width='96%' marginLeft='2%' height='75%' gap='10px'>
        {/* <ColumnFlexDiv> */}
        <RowFlexDiv width='100%' height='10%'>
          <RowFlexDiv gap='5px'>
            <Icon
              width='20px'
              height='20px'
              src='/images/mainView/assignmentsView/chat-icon.svg'
            />
            <NudistaBold14 color='primary'>Chat</NudistaBold14>
          </RowFlexDiv>
          <Icon
            width='20px'
            height='20px'
            src='/images/mainView/assignmentsView/close.svg'
            onClick={() => {
              setChatView(false)
              console.log('chat View is', false)
            }}
          />
        </RowFlexDiv>
        <MessageRow />
        <MessageReply />
        <VoiceMessage />
        <AudioMessage />
        {/* <MessageRow /> */}
      </ColumnFlexDiv>
      <ColumnFlexDiv width='96%' marginLeft='2%' height='120px' gap='5px'>
        <SendTab />
        <RowFlexDiv height='60px' width='96%' marginLeft='2%'>
          <ColumnFlexDiv alignItems='center' justifyContent='center' gap='5px'>
            <IconDiv
              image='/images/mainView/assignmentsView/voice-text.svg'
              backgroundColor='#6f03fd'
            />
            <NudistaMedium11>Audio Message</NudistaMedium11>
          </ColumnFlexDiv>
          <ColumnFlexDiv alignItems='center' justifyContent='center' gap='5px'>
            <IconDiv
              image='/images/mainView/assignmentsView/chat-actions-camera.svg'
              backgroundColor='#6f03fd'
            />
            <NudistaMedium11>Take Photo</NudistaMedium11>
          </ColumnFlexDiv>
          <ColumnFlexDiv alignItems='center' justifyContent='center' gap='5px'>
            <IconDiv
              image='/images/mainView/assignmentsView/chat-actions-library.svg'
              backgroundColor='#6f03fd'
            />
            <NudistaMedium11>Library</NudistaMedium11>
          </ColumnFlexDiv>
        </RowFlexDiv>
      </ColumnFlexDiv>
    </SideDiv>

    // <ColumnFlexDiv width='100vh' height='100vh' gap='6%' alignItems='center'>
    // </ColumnFlexDiv>
  )
}
const ShareScreen = ({ width, shareView, setShareView }) => {
  return (
    <SideDiv
      right={shareView ? '0%' : '25%'}
      width={width}
      visibility={shareView ? 'visible' : 'hidden'}
      opacity={shareView ? 1 : 0}
      height='100vh'
      padding='1%'
      // gap='10px'
      zIndex='3333'
      boxShadow='0 3px 9px 0 rgba(0, 0, 0, 0.19)'
      backgroundColor='#ffffff'
      //backgroundColor='#123486'
    >
      <ColumnFlexDiv
        width='96%'
        marginLeft='2%'
        height='100%'
        gap='2%'
        marginTop='8%'
        position='relative'
      >
        <RowFlexDiv
          width='100%'
          height='5%'
          opacity='0.41'
          // marginBottom='5px'
        >
          <RowFlexDiv gap='5px'>
            <Icon
              width='20px'
              height='20px'
              src='/images/mainView/assignmentsView/share_1.svg'
            />
            <NudistaBold14 color='primary'>Share</NudistaBold14>
          </RowFlexDiv>
          <Icon
            width='20px'
            height='20px'
            src='/images/mainView/assignmentsView/close.svg'
            onClick={() => {
              setShareView(false)
              console.log('chat View is', false)
            }}
          />
        </RowFlexDiv>
        <RowFlexDiv width='100%' marginTop='20px' justifyContent='flex-start'>
          <Icon
            width='20px'
            height='20px'
            src='/images/mainView/assignmentsView/link.svg'
            // transform='rotate(90deg)'
          />
        </RowFlexDiv>
        <NudistaBold14 color='Black'>Share This</NudistaBold14>

        <NudistaMedium14 Color='Black' opacity='0.57'>
          Share the link below with someone to provide limited access to this
          assignment
        </NudistaMedium14>

        <SearchFlexDiv
          width='96%'
          justifyContent='center'
          alignSelf='center'
          height='31px'
          backgroundColor='#FFFFFF'
          marginBottom='3%'
          borderRadius='10px'
          boxShadow='0px 3px 6px 0px rgba(0, 0, 0, 0.16)'
          padding='2%'
        >
          <SInput
            placeholderFont='11px'
            paddingLeft='10px'
            width='75%'
            height='100%'
            placeholderOpaciy='1'
            placeholder={'Https://photoid.assignment/jdoqw'}
          />
          <Icon src='/images/mainView/assignmentsView/copy-link-group.svg' />
        </SearchFlexDiv>
        <ColumnFlexDiv height='100px' gap='8px'>
          <NudistaMedium14 color='purple'>
            The Recipient is not on Photo ID
          </NudistaMedium14>
          <RowFlexDiv marginLeft='2%' width='50%'>
            <RowFlexDiv justifyContent='flex-start' gap='8px'>
              <RadioButton checkedColor='#6A26CA' />

              <NudistaMedium9 opacity='0.57' color='Black'>
                Email
              </NudistaMedium9>
            </RowFlexDiv>
            <RowFlexDiv justifyContent='flex-start' gap='8px'>
              <RadioButton checkedColor='#6A26CA' />

              <NudistaMedium9 opacity='0.57' color='Black'>
                SMS
              </NudistaMedium9>
            </RowFlexDiv>
          </RowFlexDiv>
          <RowFlexDiv
            justifyContent='flex-start'
            height='50%'
            gap='10%'
            justifyContent='center'
            alignItems='center'
          >
            <InputView width='20%' height={'25px'} title='001' />
            <InputView width='60%' height={'25px'} title='000-000-000' />
          </RowFlexDiv>
        </ColumnFlexDiv>

        <ColumnFlexDiv gap='5px' height='70px'>
          <NudistaMedium14 color='purple'>
            The Recipient is already a User
          </NudistaMedium14>
          <InputView width='95%' title='Enter Username' />
        </ColumnFlexDiv>

        <ColumnFlexDiv
          gap='12px'
          height='180px'
          justifyContent='flex-start'
          alignItems='center'
        >
          <RowFlexDiv width='100%'>
            <NudistaMedium14 color='purple'>
              Want to Add a Message?
            </NudistaMedium14>
          </RowFlexDiv>
          <SearchFlexDiv
            width='96%'
            height='95px'
            justifyContent='flex-start'
            alignItems='flex-start'
            marginBottom='3%'
            borderRadius='10px'
            padding='2% 0 4% 0'
          >
            <TextArea height='100%'>
              Please click on the link to access assignments ABB344F2 webpage
            </TextArea>
          </SearchFlexDiv>

          <RowFlexDiv height='38px' width='98%' opacity='0.75'>
            <Button
              width='98%'
              height='30px'
              icon='/images/mainView/assignmentsView/send-icon.svg'
              title='Send Invite'
              backgroundColor='#8C47ED'
              justifyContent='center'
              borderRadius='5px'
            />
          </RowFlexDiv>
        </ColumnFlexDiv>
      </ColumnFlexDiv>
    </SideDiv>
  )
}

const InputView = ({ width, height, title }) => {
  return (
    <SearchFlexDiv
      width={width || '96%'}
      height={height || '31px'}
      justifyContent='center'
      alignSelf='center'
      backgroundColor='#FFFFFF'
      marginBottom='3%'
      borderRadius='10px'
      boxShadow='0px 3px 6px 0px rgba(0, 0, 0, 0.16)'
      padding='2%'
    >
      <SInput
        placeholderFont='12px'
        paddingLeft='10px'
        width='95%'
        height='100%'
        placeholder={title}
      />
    </SearchFlexDiv>
  )
}
const LiveScreen = ({ width, liveView, setLiveView }) => {
  return (
    <SideDiv
      right={liveView ? '0%' : '25%'}
      width={width}
      visibility={liveView ? 'visible' : 'hidden'}
      opacity={liveView ? 1 : 0}
      height='100vh'
      // gap='10px'
      padding='1%'
      zIndex='3333'
      boxShadow='0 3px 9px 0 rgba(0, 0, 0, 0.19)'
      backgroundColor='#ffffff'
    >
      <RowFlexDiv
        width={liveView ? '100%' : '0px'}
        marginTop='20px'
        justifyContent='flex-end'
      >
        <Icon
          width='15px'
          height='15px'
          src='/images/mainView/assignmentsView/dropdown.svg'
          transform='rotate(90deg)'
        />
      </RowFlexDiv>
      <ColumnFlexDiv
        width='96%'
        marginLeft='2%'
        height='100%'
        gap='2%'
        marginTop='%'
      >
        <RowFlexDiv
          width='100%'
          height='3%'
          opacity='0.41'
          // marginBottom='5px'
        >
          <RowFlexDiv gap='5px'>
            <Icon
              width='15px'
              height='15px'
              src='/images/mainView/assignmentsView/remote-capture-icon.svg'
            />
            <NudistaBold14 color='primary'>REMOTE CAPTURE</NudistaBold14>
          </RowFlexDiv>
          <Icon
            width='20px'
            height='20px'
            src='/images/mainView/assignmentsView/close.svg'
            onClick={() => {
              setLiveView(false)
              console.log('chat View is', false)
            }}
          />
        </RowFlexDiv>
        <RowFlexDiv
          width='100%'
          height='15px'
          marginTop='5px'
          justifyContent='flex-start'
        >
          <Icon
            width='20px'
            height='20px'
            src='/images/mainView/assignmentsView/link.svg'
            // transform='rotate(90deg)'
          />
        </RowFlexDiv>
        <RowFlexDiv width='60%' height='25px'>
          <NudistaBoldCustomFont fontSize='16px' color='Black'>
            Virtual Inspection Camera
          </NudistaBoldCustomFont>
        </RowFlexDiv>

        <NudistaMedium14 Color='Black' opacity='0.57'>
          Share the link below with your partner to join the call
        </NudistaMedium14>

        <SearchFlexDiv
          width='94%'
          justifyContent='center'
          alignSelf='center'
          height='25px'
          backgroundColor='#FFFFFF'
          borderRadius='10px'
          boxShadow='0px 3px 3px 0px rgba(0, 0, 0, 0.16)'
          padding='2%'
        >
          <SInput
            placeholderFont='11px'
            paddingLeft='10px'
            width='75%'
            height='100%'
            placeholderOpaciy='1'
            placeholder={'Https://photoid.assignment/jdoqw'}
          />
          <Icon
            width='30px'
            height='30px'
            src='/images/mainView/assignmentsView/copy-link-group_dark.svg'
          />
        </SearchFlexDiv>
        <NudistaBold14 color='primary'>
          Or choose one of the options
        </NudistaBold14>

        <ColumnFlexDiv height='110px' gap='12px' justifyContent='center'>
          <NudistaBold12 color='primary'>
            The Recipient is not on Photo ID
          </NudistaBold12>
          <RowFlexDiv marginLeft='2%' width='50%' gap='25%'>
            <RowFlexDiv justifyContent='flex-start' gap='8px'>
              <RadioButton checkedColor='#6A26CA' />

              <NudistaMedium9 opacity='0.57' color='Black'>
                Email
              </NudistaMedium9>
            </RowFlexDiv>
            <RowFlexDiv justifyContent='flex-start' gap='8px'>
              <RadioButton checkedColor='#6A26CA' />

              <NudistaMedium9 opacity='0.57' color='Black'>
                SMS
              </NudistaMedium9>
            </RowFlexDiv>
          </RowFlexDiv>
          <InputView width='94%' height='35px' title='Enter Email' />
        </ColumnFlexDiv>

        <ColumnFlexDiv gap='2px' height='10%'>
          <NudistaMedium14 color='purple'>
            The Recipient is already a User
          </NudistaMedium14>
          <InputView width='94%' title='Enter Username' />
        </ColumnFlexDiv>

        <ColumnFlexDiv gap='8px'>
          <NudistaMedium14 color='purple'>
            Want to Add a Message?
          </NudistaMedium14>
          <SearchFlexDiv
            width='96%'
            height='50%'
            justifyContent='center'
            alignSelf='center'
            marginBottom='3%'
            borderRadius='10px'
            boxShadow='3px 3px 6px 3px rgba(0, 0, 0, 0.16)'
            padding='2% 0 4% 0'
          >
            <TextArea height='100%'>
              Please click on the link to access assignments ABB344F2 webpage
            </TextArea>
          </SearchFlexDiv>

          <RowFlexDiv justifyContent='center'>
            <Icon
              width='60px'
              height='60px'
              src='/images/mainView/assignmentsView/qr-code-styling.png'
            />
          </RowFlexDiv>

          <RowFlexDiv opacity='0.7' justifyContent='center'>
            <Button
              width='95%'
              height='30px'
              icon='/images/mainView/assignmentsView/send-icon.svg'
              title='Invite & Join'
              backgroundColor='#8C47ED'
              justifyContent='center'
              borderRadius='5px'
            />
          </RowFlexDiv>
        </ColumnFlexDiv>
      </ColumnFlexDiv>
    </SideDiv>
  )
}

const VoiceMessage = () => {
  return (
    <ColumnFlexDiv
      height='18px'
      alignItems='center'
      backgroundColor='#6A26CA'
      padding='10px'
      gap='5px'
      borderRadius='25px'
    >
      <RowFlexDiv width='100%' height='100%'>
        <Icon src='/images/mainView/assignmentsView/voice-text.svg' />

        <RowFlexDiv
          width='80%'
          height='2px'
          backgroundColor='rgb(239,232,429,0.5)'
        >
          <RowFlexDiv
            width='15px'
            height='15px'
            borderRadius='50%'
            backgroundColor='#ffffff'
          ></RowFlexDiv>
        </RowFlexDiv>

        <NudistaMedium11 white>00:12</NudistaMedium11>
      </RowFlexDiv>
    </ColumnFlexDiv>
  )
}

const AudioMessage = () => {
  return (
    <ColumnFlexDiv
      height='18px'
      alignItems='center'
      backgroundColor='#FB8F02'
      padding='10px'
      gap='5px'
      borderRadius='25px'
    >
      <RowFlexDiv width='100%' height='100%' gap='5px'>
        <Icon src='/images/mainView/assignmentsView/speaker.svg' />
        <NudistaMedium9 white>ONGOING AUDIO CHAT</NudistaMedium9>

        <NudistaMedium11 white>00:12</NudistaMedium11>
        <Icon src='/images/mainView/assignmentsView/soundwave.svg' />

        <Icon src='/images/mainView/assignmentsView/close-circle-sharp.svg' />
      </RowFlexDiv>
    </ColumnFlexDiv>
  )
}

const MessageRow = () => {
  return (
    <ColumnFlexDiv
      // height='25%'
      alignItems='center'
      backgroundColor='#F6F2FC'
      padding='10px'
      gap='5px'
    >
      <ProfileChatRow />
      <NudistaSemiBold11 fontSize='12px' width='96%'>
        Hi, Earl! Can you do this one for me? I had a family. I am doing this
      </NudistaSemiBold11>
      <Icon
        width='100%'
        height='100px'
        src='/images/mainView/assignmentsView/BuildingImage.jpg'
      />
    </ColumnFlexDiv>
  )
}

const ProfileChatRow = () => {
  return (
    <RowFlexDiv width='96%'>
      <RowFlexDiv gap='5px'>
        <UserProfilePictureHolder>
          <UserProfilePicture
            width='35px'
            src='/images/navbar/stock_profile.jpg'
          />
        </UserProfilePictureHolder>
        <ColumnFlexDiv>
          <NudistaSemiBold11 color='primary' fontSize='12px'>
            Chad Smith
          </NudistaSemiBold11>
          <NudistaMedium11 opacity='0.6'>12m.</NudistaMedium11>
        </ColumnFlexDiv>
      </RowFlexDiv>
      <RowFlexDiv gap='5px'>
        <Icon src='/images/mainView/assignmentsView/reply-fill.svg' />
      </RowFlexDiv>
    </RowFlexDiv>
  )
}

const MessageReply = () => {
  return (
    <RowFlexDiv
      width='92%'
      justifyContent='flex-start'
      backgroundColor='#F5F4F7'
      padding='10px'
    >
      <ColumnFlexDiv
        width='1px'
        height='100%'
        marginLeft='10%'
        backgroundColor='#6f03fd'
      ></ColumnFlexDiv>
      <ColumnFlexDiv width='100%' height='100%' alignitems='center' gap='5px'>
        <RowFlexDiv width='90%' height='30%' marginLeft='5%'>
          <NudistaSemiBold11 color='primary' fontSize='12px'>
            You Replied
          </NudistaSemiBold11>
          <NudistaMedium12 opacity='0.5'>Just now</NudistaMedium12>
        </RowFlexDiv>
        <RowFlexDiv
          width='95%'
          justifyContent='flex-start'
          alignSelf='flex-start'
        >
          <RowFlexDiv marginLeft='6%'>
            <NudistaSemiBold11 fontSize='12px'>
              Hi, Earl! Can you do this one for me? I had a family. I am doing
              this to
            </NudistaSemiBold11>
          </RowFlexDiv>
        </RowFlexDiv>
      </ColumnFlexDiv>
    </RowFlexDiv>
  )
}

const Button = ({
  width,
  height,
  icon,
  title,
  backgroundColor,
  justifyContent,
  handleClick,
  borderRadius,
}) => {
  return (
    <RowFlexDiv
      width={width}
      height={height}
      justifyContent={justifyContent || 'flex-start'}
      backgroundColor={backgroundColor}
      // padding='0 0 0 3%'
      padding='1%'
      gap='5%'
      Cursor='pointer'
      borderRadius={borderRadius}
      onClick={handleClick}
    >
      <Icon marginLeft='2%' src={icon} />
      <HelveticaNeueBold14 white>{title}</HelveticaNeueBold14>
    </RowFlexDiv>
  )
}

const SideDiv = styled.div`
  position: absolute;
  top: 0%;
  right: ${(prop) => prop.right || '25%'};
  /* right: '25%'; */
  /* right: 22.2%; */
  /* left: 0%; */

  display: block;
  flex-direction: column;
  text-overflow: ellipsis;

  visibility: ${(props) => props.visibility};

  width: ${({ width }) => width};
  height: ${({ height }) => height};
  opacity: ${({ opacity }) => opacity};
  z-index: ${({ zIndex }) => zIndex};
  overflow: ${({ overflow }) => overflow};
  outline: ${(props) => props.outline};

  transition: width 0.5s, opacity 0.5s;

  padding: ${({ padding }) => padding};

  gap: ${({ gap }) => gap};
  margin: ${({ margin }) => margin};

  margin-left: ${(props) => props.marginLeft};
  margin-top: ${(props) => props.marginTop};
  margin-bottom: ${(props) => props.marginBottom};
  :hover {
  }
  :active {
    /* transition: width 2s; */
  }
  box-shadow: ${(props) => props.boxShadow};
  background-color: ${(props) => props.backgroundColor};
  border-radius: ${(props) => props.borderRadius};
  border: ${(props) => props.border};
  justify-content: ${(props) => props.justifyContent};
  align-items: ${(props) => props.alignItems};
`

export default ChatTab
